// extracted by mini-css-extract-plugin
export default {"card":"ArticleCard_card__-4D01","heroImage":"ArticleCard_heroImage__hfrH3","description":"ArticleCard_description__KwIBF","link":"ArticleCard_link__HFtlP"};